import React, { useEffect, useState } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import logo1 from '../assets/logo1.webp';
import logo2 from '../assets/logo2.webp';
import logo3 from '../assets/logo3.webp';
import logo4 from '../assets/logo4.webp';

export default function Logo() {
  const [activeLogo, setActiveLogo] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  const scrollToElement = (id, logoIndex) => {
    setActiveLogo(logoIndex);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center', // Aligns the element in the center
      });
    }
  };

  return (
    <div className="flex justify-center pt-2 lg:pt-10 md:pb-0">
      <div data-aos="flip-up" className="flex flex-wrap items-center justify-center space-x-4 logo-section">
        {[logo1, logo2, logo3, logo4].map((logo, index) => (
          <div
            key={index}
            className={`w-16 h-16 m-2 rounded-lg shadow-lg transition-all duration-300 ease-out transform sm:w-20 sm:h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 xl:w-32 xl:h-32 ${activeLogo === index ? 'bg-yellow-100' : 'bg-blue-light'} hover:bg-yellow-100 hover:scale-105`}
            onClick={() => scrollToElement(`scholarship-${index}`, index)}
          >
            <button className="w-full h-full">
              <img src={logo} alt={`Logo ${index + 1}`} className="object-cover w-full h-full rounded-lg" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
